import { render, staticRenderFns } from "./Consultor.vue?vue&type=template&id=e9d645b4&"
import script from "./Consultor.vue?vue&type=script&lang=js&"
export * from "./Consultor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports